export const mapData = [
  {
    location: {
      y: 1.318593300920971,
      x: 103.84299744166285,
      address: "51 GOLDHILL PLAZA, #07-10/11 SINGAPORE 308900",
    },
  },
];
